import Firebase from 'firebase'
import jwtDecode from 'jwt-decode'
import router from '@/router'
import Vue from 'vue'
import sessionEvent from '@/util/sessionEvent'
// import VueLocalStorage from 'vue-localstorage'

// Vue.use(VueLocalStorage)

export default {
  namespaced: true,
  state: {
    user: null,
    session: null,
    isLoggedIn: false,
    isSessionSet: false
  },
  mutations: {
    SET_USER (state, payload) {
      state.user = payload
      state.isLoggedIn = true
    },
    CLEAR_USER (state) {
      state.user = null
      state.isLoggedIn = false
    },
    SET_USER_LOGIN_STATUS (state, booleanPayload) {
      state.isLoggedIn = booleanPayload
    },
    SET_SESSION (state, sessionObject) {
      state.session = Object.assign({}, sessionObject)
      state.isSessionSet = true
    },
    CLEAR_SESSION (state) {
      state.session = null
      state.isSessionSet = false
    }
  },
  actions: {
    login ({ commit }, jwtToken) {
      Firebase.auth().setPersistence(Firebase.auth.Auth.Persistence.SESSION)
        .then(function () {
          Firebase
            .auth()
            .signInWithCustomToken(jwtToken)
            .then(async (user) => {
              const fbJwt = await user.getIdToken()
              const decodedJwt = jwtDecode(fbJwt)

              sessionEvent(decodedJwt.sessionKey, 'login_via_link', { email: decodedJwt.email })

              commit('SET_USER', {
                id: user.uid,
                name: user.displayName,
                email: decodedJwt.email,
                photoURL: user.photoURL,
                metadata: user.metadata,
                sessionKey: decodedJwt.sessionKey
              })

              Vue.$storage.set('session_key', decodedJwt.sessionKey)
            })
            .catch(err => {
              console.dir(err)
            })
        })
        .catch(function (error) {
          const errCode = error.errCode
          const errMessage = error.message

          console.log(errCode + ' ' + errMessage)
        })
    },
    async autoSignIn ({commit}, payload) {
      const fbJwt = await payload.getIdToken()
      const decodedJwt = jwtDecode(fbJwt)

      console.group('TIMEZ')
      console.log(decodedJwt)
      console.log(new Date(decodedJwt.auth_time * 1000))
      console.log(new Date())
      const authDate = new Date(decodedJwt.auth_time * 1000)
      const nowDate = new Date()

      const diffDate = nowDate - authDate

      console.log(diffDate)
      console.log(Math.floor((nowDate - authDate) / (1000 * 60 * 60 * 24)))
      console.groupEnd()

      commit('SET_USER', {
        id: payload.uid,
        name: payload.displayName,
        email: decodedJwt.email,
        photoUrl: payload.photoURL,
        metadata: payload.metadata,
        sessionKey: decodedJwt.sessionKey
      })
    },
    logout ({ commit }) {
      Firebase.auth().signOut()
      commit('CLEAR_USER')
      commit('CLEAR_SESSION')
      router.push({ name: 'Login' })
    },
    setNewSession ({ commit }, sessionObject) {
      return new Promise((resolve, reject) => {
        commit('SET_SESSION', sessionObject)
        resolve({test: 'test'})
      })
    },
    clearSession ({ commit }) {
      commit('CLEAR_SESSION')
      router.push({ name: 'Session' })
    }
    // signUserIn ({commit}, payload) {
    //   Firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
    //     .then(
    //       user => {
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('SET_USER', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         console.log(error)
    //       }
    //     )
    // }
  },
  getters: {
    user (state) {
      return state.user
    },
    session (state) {
      return state.session
    },
    isLoggedIn (state) {
      return state.isLoggedIn
    },
    isSessionSet (state) {
      return state.isSessionSet
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js